'use client';

import React, { useEffect, useState } from 'react';
import { rafThrottle } from '@/lib/scroll-utils';
import styles from './ScrollProgress.module.css';

/**
 * ScrollProgress Component
 * Shows a progress bar indicating how far the user has scrolled down the page
 */
export function ScrollProgress() {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const updateScrollProgress = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY;

      // Calculate scroll percentage
      const scrollableHeight = documentHeight - windowHeight;
      const progress = scrollableHeight > 0 ? (scrollTop / scrollableHeight) * 100 : 0;

      setScrollProgress(Math.min(progress, 100));
    };

    // Initial calculation
    updateScrollProgress();

    // Throttle scroll updates for better performance
    const throttledScroll = rafThrottle(updateScrollProgress);
    const throttledResize = rafThrottle(updateScrollProgress);

    // Update on scroll
    window.addEventListener('scroll', throttledScroll, { passive: true });
    
    // Update on resize (in case content changes)
    window.addEventListener('resize', throttledResize, { passive: true });

    return () => {
      window.removeEventListener('scroll', throttledScroll);
      window.removeEventListener('resize', throttledResize);
    };
  }, []);

  return (
    <div className={styles.scrollProgressContainer}>
      <div 
        className={styles.scrollProgressBar}
        style={{ width: `${scrollProgress}%` }}
      />
    </div>
  );
}

